import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { useIdentityClient, useUser } from "../../hooks";

import { PasswordResetCompleteTemplate } from "./password-reset-complete.template";

export const PasswordResetComplete = () => {
	const navigate = useNavigate();
	const { client } = useIdentityClient();
	const intl = useIntl();
	const { refreshUser } = useUser();

	const [submitting, setSubmitting] = useState(false);
	const [errors, setErrors] = useState<string | null>(null);

	const handleSubmit = async (password: string) => {
		setSubmitting(true);
		setErrors(null);
		try {
			const result = await client.forgotPasswordReset({ password });

			if (result.success === true) {
				await refreshUser();
				navigate("/login");
			} else {
				setErrors(
					intl.formatMessage({
						id: "password-reset-complete.error",
						defaultMessage: "Unable to reset password. Please try again.",
					}),
				);
			}
		} catch {
			setErrors(
				intl.formatMessage({
					id: "password-reset-complete.error",
					defaultMessage: "Unable to reset password. Please try again.",
				}),
			);
		} finally {
			setSubmitting(false);
		}
	};

	return <PasswordResetCompleteTemplate onSubmit={handleSubmit} isSubmitting={submitting} errorMessage={errors} />;
};
